module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flex-center-col"
  }, [_c('button', {
    class: _vm.mode ? 'active' : null,
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        return _vm.selectMode(true)
      }
    }
  }, [_vm._v("שחקן יחיד")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playerName),
      expression: "playerName"
    }],
    staticStyle: {
      "direction": "rtl",
      "fontSize": "30px"
    },
    attrs: {
      "type": "text",
      "placeholder": "הכנס שם"
    },
    domProps: {
      "value": (_vm.playerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playerName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.startGame
    }
  }, [_vm._v("התחל")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "direction": "rtl",
      "fontSize": "50px",
      "border": "10px black !important"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(" שם שחקן ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("תוצאה  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(" תאריך משחק ")]), _vm._v(" "), _vm._l((_vm.playersList), function(player) {
    return _c('tr', {
      staticStyle: {
        "direction": "rtl",
        "fontSize": "50px",
        "border": "10px honeydew !important",
        "color": "honeydew",
        "bold": "bold",
        "text-align": "center"
      }
    }, [_c('td', [_vm._v(" " + _vm._s(player.playerName))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(player.score))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "400px",
        "fontSize": "30px"
      }
    }, [_vm._v(_vm._s(new Date(player.time).toLocaleTimeString() + '  ' + new Date(player.time).toLocaleDateString()) + "  ")])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9e749f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Starter.vue
// module id = 53
// module chunks = 0